import React from 'react';
import { BookOpen, Grid, ShoppingCart, CalendarDays, Home, Gift, CheckCircle2 } from 'lucide-react';
export function Deliverables() {
  const items = [{
    icon: <BookOpen className="w-6 h-6 text-teal-600" data-id="element-14" />,
    title: 'El Manual Paso a Paso del Método MIC',
    desc: 'PDF de lectura rápida, directo al grano.'
  }, {
    icon: <Grid className="w-6 h-6 text-teal-600" data-id="element-15" />,
    title: "Técnica de 'Seccionado por Cuadrantes'",
    desc: 'Para no dejar una sola liendre atrás.'
  }, {
    icon: <ShoppingCart className="w-6 h-6 text-teal-600" data-id="element-16" />,
    title: 'Lista de Compras Táctica',
    desc: 'Qué pedir en Amazon o buscar en CVS que realmente funciona.'
  }, {
    icon: <CalendarDays className="w-6 h-6 text-teal-600" data-id="element-17" />,
    title: 'Plan de Acción de 7 Días',
    desc: 'Qué hacer exactamente cada mañana y cada noche.'
  }, {
    icon: <Home className="w-6 h-6 text-teal-600" data-id="element-18" />,
    title: 'Guía de Blindaje del Hogar',
    desc: 'Cómo limpiar tu casa en 2 horas sin volverte loca.'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-19">
      <div className="max-w-4xl mx-auto" data-id="element-20">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center text-slate-900 mb-12" data-id="element-21">
          Lo que obtienes hoy mismo
        </h2>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-22">
          <div className="space-y-4" data-id="element-23">
            {items.map((item, idx) => <div key={idx} className="flex gap-4 p-4 rounded-xl border border-slate-100 bg-slate-50 hover:border-teal-200 hover:bg-teal-50/50 transition-colors" data-id="element-24">
                <div className="mt-1" data-id="element-25">{item.icon}</div>
                <div data-id="element-26">
                  <h4 className="font-bold text-slate-900" data-id="element-27">{item.title}</h4>
                  <p className="text-slate-600 text-sm mt-1" data-id="element-28">{item.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="bg-gradient-to-br from-teal-600 to-teal-800 rounded-2xl p-8 text-white shadow-xl flex flex-col justify-center relative overflow-hidden" data-id="element-29">
            <div className="absolute top-0 right-0 w-32 h-32 bg-white opacity-5 rounded-full -mr-10 -mt-10" data-id="element-30"></div>
            <div className="absolute bottom-0 left-0 w-24 h-24 bg-white opacity-5 rounded-full -ml-10 -mb-10" data-id="element-31"></div>

            <div className="flex items-center gap-3 mb-6" data-id="element-32">
              <Gift className="w-8 h-8 text-amber-400" data-id="element-33" />
              <h3 className="text-2xl font-bold text-amber-400" data-id="element-34">
                BONUS EXCLUSIVO
              </h3>
            </div>

            <h4 className="text-xl font-bold mb-4" data-id="element-35">
              Receta de repelente natural preventivo
            </h4>
            <p className="text-teal-100 mb-6" data-id="element-36">
              La fórmula exacta para preparar en casa y aplicar antes del
              regreso a clases. Evita que tu hijo se contagie de nuevo en la
              escuela.
            </p>

            <div className="flex items-center gap-2 text-sm font-bold bg-white/20 w-fit px-4 py-2 rounded-full" data-id="element-37">
              <CheckCircle2 className="w-4 h-4" data-id="element-38" />
              Incluido GRATIS con tu compra
            </div>
          </div>
        </div>
      </div>
    </section>;
}